<template>
  <div id="speakers" class="jf-speakers section padding-top-65 padding-bottom-65">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section-headline centered margin-bottom-45">
            <h3>Featured Speakers</h3>
            <span>Learn from industry leaders and career experts</span>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 margin-bottom-30" v-for="(speaker, i) in speakers" :key="i">
          <div class="jf-speakers__card">
            <div class="jf-speakers__photo">
              <img v-if="speaker.photo" :src="speaker.photo" :alt="speaker.name">
              <div v-else class="jf-speakers__placeholder">
                <i class="icon-feather-user"></i>
              </div>
            </div>
            <div class="jf-speakers__info">
              <h4>{{ speaker.name }}</h4>
              <p class="jf-speakers__title">{{ speaker.title }}<span v-if="speaker.company">, {{ speaker.company }}</span></p>
              <p class="jf-speakers__bio" v-if="speaker.bio">{{ speaker.bio }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    speakers: { type: Array, required: true }
  }
};
</script>

<style lang="scss" scoped>
.jf-speakers {
  background: #f9f9f9;

  &__card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    text-align: center;
    padding: 40px 25px 35px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s, box-shadow 0.2s;
    height: 100%;
    border-top: 4px solid #2a41e8;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12);
    }
  }

  &__photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 25px;
    box-shadow: 0 4px 15px rgba(42, 65, 232, 0.2);
    border: 4px solid #fff;
    outline: 3px solid #2a41e8;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
  }

  &__placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #2a41e8, #4a6cf7);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    i {
      font-size: 50px;
      color: #fff;
    }
  }

  &__info {
    h4 {
      margin: 0 0 8px;
      font-size: 22px;
      font-weight: 700;
      color: #222;
    }
  }

  &__title {
    margin: 0 0 4px;
    color: #2a41e8;
    font-size: 15px;
    font-weight: 600;
  }

  &__bio {
    margin: 12px 0 0;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
  }
}
</style>
